import { toast } from 'sonner';

type ToastType = 'error' | 'success' | 'info';

interface ToastOptions {
  title: string;
  message?: string;
  type?: ToastType;
}

const toastApi = {
  show(options: ToastOptions) {
    const fn =
      options.type === 'error'
        ? toast.error
        : options.type === 'success'
          ? toast.success
          : toast.info;
    fn(options.title, {
      description: options.message,
      duration: options.type === 'error' ? 5000 : 3000,
    });
  },

  error(title: string, message?: string) {
    toast.error(title, { description: message, duration: 5000 });
  },

  success(title: string, message?: string) {
    toast.success(title, { description: message, duration: 3000 });
  },

  dismiss() {
    toast.dismiss();
  },
};

export function useToast() {
  return toastApi;
}
